import { render, staticRenderFns } from "./tambahiklan.vue?vue&type=template&id=14f142aa&"
import script from "./tambahiklan.vue?vue&type=script&lang=js&"
export * from "./tambahiklan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports